import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { auth, db } from '@/firebaseConfig';
import { UserData } from '@/constants/types';
// import { get } from 'http';

export default {
  namespaced: true,
  state: {
    data: null,
    auth: {
      isProcessing: false,
      error: '',
    },
    unsubscribe: [],
  },
  getters: {
    isAuthenticated(state: any) {
      return !!state.data;
    },
    isOwner(state: any) {
      return state.data?.role === 'owner';
    },
  },
  actions: {
    onAuthChange({ dispatch, commit }: any, callback: any) {
      console.log('onAuthChange');
      commit('setAuthProcessing', true);
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          await dispatch('getUserProfile', user);
          commit('setAuthProcessing', false);
          callback(user);
        } else {
          console.log('Logged out');
          commit('setAuthProcessing', false);
          callback(null);
        }
      });
    },
    async register({ commit, dispatch }: any, { email, password, username }: any) {
      console.log('register', email, password, username);
      commit('setAuthProcessing', true);
      commit('setAuthError', '');

      try {
        const { user } = await createUserWithEmailAndPassword(auth, email, password);
        await dispatch('createUserProfile', {
          id: user.uid,
          username,
        });
      } catch (err: any) {
        commit('setAuthError', err.message);
        dispatch('toast/error', err.message, { root: true });
      } finally {
        commit('setAuthProcessing', false);
      }
    },
    async login({ commit, dispatch }: any, { email, password }: any) {
      console.log('login', email, password);
      commit('setAuthProcessing', true);
      commit('setAuthError', '');

      try {
        await signInWithEmailAndPassword(auth, email, password);
      } catch (err: any) {
        commit('setAuthError', err.message);
        dispatch('toast/error', err.message, { root: true });
      } finally {
        commit('setAuthProcessing', false);
      }
    },
    async logout({ commit, dispatch }: any) {
      try {
        console.log('logOut action called');
        commit('setUser', null);
        await auth.signOut();
        dispatch('toast/success', 'Logged out successfully', { root: true });
      } catch (err: any) {
        commit('setAuthError', err.message);
        dispatch('toast/error', err.message, { root: true });
      }
    },
    async createUserProfile(_: any, { id, ...profile }: any) {
      console.log('createUserProfile', id, profile);
      await setDoc(doc(db, 'users', id), { ...profile, id });
    },
    async updateProfile({ commit, dispatch }: any, { data, onSuccess }: any) {
      console.log('updateProfile', data);
      try {
        const userRef = doc(db, 'users', data.id);
        await updateDoc(userRef, data);
        commit('updateProfile', data);
        dispatch('toast/success', 'Profile updated successfully', { root: true });
        onSuccess();
      } catch (err: any) {
        dispatch('toast/error', err.message, { root: true });
      }
    },
    async getUserProfile({ commit }: any, user: any) {
      const userRef = doc(db, 'users', user.uid);
      const docSnap = await getDoc(userRef);
      if (docSnap.exists()) {
        const userWithProfile = {
          id: user.uid,
          ...docSnap.data() as UserData,
        };
        commit('setUser', userWithProfile);
      }
    },
  },
  mutations: {
    setAuthProcessing(state: any, isProcessing: boolean) {
      state.auth.isProcessing = isProcessing;
    },
    setAuthError(state: any, error: string) {
      state.auth.error = error;
    },
    setUser(state: any, user: any) {
      state.data = user;
    },
  },
};
